const initialState = {
  nameProperty: localStorage.getItem('nameProperty'),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'NAME_PROPERTY':
      const { nameProperty } = action;
      return {
        ...state,
        nameProperty,
      };
    default:
      return state;
  }
};

export const setNameProperty = (
  nameProperty,
) => ({
  type: 'NAME_PROPERTY',
  nameProperty,
});
